"use strict";

var _classCallCheck = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linker = void 0;

var Utils_1 = require("../../Utils");

var Linker = /*#__PURE__*/function () {
  function Linker(container) {
    _classCallCheck(this, Linker);

    this.container = container;
  }

  _createClass(Linker, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.particlesOptions.links.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var _a;

      var container = this.container;
      var linkOpt1 = p1.particlesOptions.links;
      var optOpacity = linkOpt1.opacity;
      var optDistance = (_a = p1.linksDistance) !== null && _a !== void 0 ? _a : container.retina.linksDistance;
      var canvasSize = container.canvas.size;
      var warp = linkOpt1.warp;
      var pos1 = p1.getPosition();
      var range = warp ? new Utils_1.CircleWarp(pos1.x, pos1.y, optDistance, canvasSize) : new Utils_1.Circle(pos1.x, pos1.y, optDistance);
      var query = container.particles.quadTree.query(range);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p2 = _step.value;
          var linkOpt2 = p2.particlesOptions.links;

          if (p1 === p2 || !linkOpt2.enable || linkOpt1.id !== linkOpt2.id || p2.spawning || p2.destroyed) {
            continue;
          }

          var pos2 = p2.getPosition();
          var distance = Utils_1.NumberUtils.getDistance(pos1, pos2);

          if (warp) {
            if (distance > optDistance) {
              var pos2NE = {
                x: pos2.x - canvasSize.width,
                y: pos2.y
              };
              distance = Utils_1.NumberUtils.getDistance(pos1, pos2NE);

              if (distance > optDistance) {
                var pos2SE = {
                  x: pos2.x - canvasSize.width,
                  y: pos2.y - canvasSize.height
                };
                distance = Utils_1.NumberUtils.getDistance(pos1, pos2SE);

                if (distance > optDistance) {
                  var pos2SW = {
                    x: pos2.x,
                    y: pos2.y - canvasSize.height
                  };
                  distance = Utils_1.NumberUtils.getDistance(pos1, pos2SW);
                }
              }
            }
          }

          if (distance > optDistance) {
            return;
          }

          var opacityLine = (1 - distance / optDistance) * optOpacity;
          var linksOptions = p1.particlesOptions.links;
          var linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;

          if (!linkColor) {
            var optColor = linksOptions.color;
            linkColor = Utils_1.ColorUtils.getLinkRandomColor(optColor, linksOptions.blink, linksOptions.consent);

            if (linksOptions.id !== undefined) {
              container.particles.linksColors.set(linksOptions.id, linkColor);
            } else {
              container.particles.linksColor = linkColor;
            }
          }

          if (p2.links.map(function (t) {
            return t.destination;
          }).indexOf(p1) === -1 && p1.links.map(function (t) {
            return t.destination;
          }).indexOf(p2) === -1) {
            p1.links.push({
              destination: p2,
              opacity: opacityLine
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Linker;
}();

exports.Linker = Linker;